<script setup lang="ts"></script>
<template>
    <div class="tw-flex tw-flex-col tw-items-center tw-gap-10">
        <svg
            width="256"
            height="308"
            viewBox="0 0 256 308"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <g clip-path="url(#clip0_1647_40561)">
                <path
                    d="M205.357 46H5.6434C2.52664 46 0 48.5206 0 51.6299V302.37C0 305.479 2.52664 308 5.6434 308H205.357C208.473 308 211 305.479 211 302.37V51.6299C211 48.5206 208.473 46 205.357 46Z"
                    fill="#DFDFDF"
                />
                <path
                    d="M185.588 67.8399H24.618C21.5012 67.8399 18.9746 70.3605 18.9746 73.4698V124.918C18.9746 128.028 21.5012 130.548 24.618 130.548H185.588C188.704 130.548 191.231 128.028 191.231 124.918V73.4698C191.231 70.3605 188.704 67.8399 185.588 67.8399Z"
                    fill="#FD7E14"
                />
                <path
                    d="M189.309 149.183H20.8964C19.835 149.183 18.9746 150.042 18.9746 151.1V157.603C18.9746 158.662 19.835 159.52 20.8964 159.52H189.309C190.371 159.52 191.231 158.662 191.231 157.603V151.1C191.231 150.042 190.371 149.183 189.309 149.183Z"
                    fill="#084298"
                />
                <path
                    d="M189.309 175.737H20.8964C19.835 175.737 18.9746 176.596 18.9746 177.655V184.157C18.9746 185.216 19.835 186.074 20.8964 186.074H189.309C190.371 186.074 191.231 185.216 191.231 184.157V177.655C191.231 176.596 190.371 175.737 189.309 175.737Z"
                    fill="#084298"
                />
                <path
                    d="M189.309 202.292H20.8964C19.835 202.292 18.9746 203.15 18.9746 204.209V210.711C18.9746 211.77 19.835 212.628 20.8964 212.628H189.309C190.371 212.628 191.231 211.77 191.231 210.711V204.209C191.231 203.15 190.371 202.292 189.309 202.292Z"
                    fill="#084298"
                />
                <path
                    d="M188.305 229.747H112.08C110.464 229.747 109.154 231.054 109.154 232.666V275.451C109.154 277.063 110.464 278.37 112.08 278.37H188.305C189.921 278.37 191.231 277.063 191.231 275.451V232.666C191.231 231.054 189.921 229.747 188.305 229.747Z"
                    fill="#084298"
                />
                <path
                    d="M99.1295 229.747H20.8964C19.835 229.747 18.9746 230.605 18.9746 231.664V238.167C18.9746 239.226 19.835 240.084 20.8964 240.084H99.1295C100.191 240.084 101.051 239.226 101.051 238.167V231.664C101.051 230.605 100.191 229.747 99.1295 229.747Z"
                    fill="#084298"
                />
                <path
                    d="M99.1295 257.431H20.8964C19.835 257.431 18.9746 258.29 18.9746 259.348V265.851C18.9746 266.91 19.835 267.768 20.8964 267.768H99.1295C100.191 267.768 101.051 266.91 101.051 265.851V259.348C101.051 258.29 100.191 257.431 99.1295 257.431Z"
                    fill="#084298"
                />
            </g>
            <circle
                cx="210.5"
                cy="45.5"
                r="40.5"
                stroke="#084298"
                stroke-width="10"
            />
            <g clip-path="url(#clip1_1647_40561)">
                <path
                    d="M226.404 56.6426L216.262 46.5L226.404 36.3574C227.649 35.1129 227.649 33.0942 226.404 31.8496L224.15 29.5957C222.906 28.3511 220.887 28.3511 219.643 29.5957L209.5 39.7383L199.357 29.5957C198.113 28.3511 196.094 28.3511 194.85 29.5957L192.596 31.8496C191.351 33.0942 191.351 35.1129 192.596 36.3574L202.738 46.5L192.596 56.6426C191.351 57.8871 191.351 59.9058 192.596 61.1504L194.85 63.4043C196.094 64.6488 198.113 64.6488 199.357 63.4043L209.5 53.2617L219.643 63.4043C220.887 64.6488 222.906 64.6488 224.15 63.4043L226.404 61.1504C227.649 59.9058 227.649 57.8871 226.404 56.6426Z"
                    fill="#084298"
                />
            </g>
            <defs>
                <clipPath id="clip0_1647_40561">
                    <rect
                        width="211"
                        height="262"
                        fill="white"
                        transform="translate(0 46)"
                    />
                </clipPath>
                <clipPath id="clip1_1647_40561">
                    <rect
                        width="51"
                        height="51"
                        fill="white"
                        transform="translate(184 21)"
                    />
                </clipPath>
            </defs>
        </svg>

        <div
            class="tw-w-full md:tw-w-2/3 tw-flex tw-flex-col tw-items-center tw-gap-4 tw-mx-auto"
        >
            <p>
                Es posible que el artículo que busca no esté disponible en este
                momento. Por favor, asegúrese de que las palabras estén escritas
                correctamente o pruebe con términos alternativos.
            </p>
            <p>
                Si necesita ayuda, no dude en contactar a nuestro servicio de
                atención al cliente al número
                <a
                    href="tel:+5359868545"
                    class="tw-text-primary tw-cursor-pointer"
                    >+53 5 9868545</a
                >
                y unirse al grupo de WhatsApp de la tienda para estar informado
                de los nuevos productos.
            </p>
            <strong class="tw-text-lg">¡Estamos aquí para ayudarle!</strong>
        </div>
    </div>
</template>